const domain = window.location.host;
let API_PATH = "";
if (domain.indexOf("developer.gartner.com") !== -1) {
  API_PATH = "https://toolsdv.gartner.com";
}

const GENIE_AUTH_ENV = {
  LOCAL: "http://toolsdv.gartner.com/account/signin",
};

export const Constants = {
  API: {
    API_PATH: API_PATH,
    BASE_URL: "/api/cyber-risk/v1",
    SEARCH: "/search/vendor",
    SEARCH_PARAMS: "?searchTerm=",
    GCMS_URL: "/api/gcms/vendors?search=",
    GCMS_SEARCH_PARAMS: "&size=50",
  },
  ROUTES: {
    BASE_URL: "/cybersecurity-insights",
    DASHBOARD: "/",
    RISK_PROFILE: "/risk-profile",
    GENIE_AUTH_URL: GENIE_AUTH_ENV.LOCAL,
  },
  SEARCH: {
    CHAR_LIMIT: 2,
    IN_MY_ORG_TITLE: "IN YOUR PORTFOLIO",
    OUTSIDE_ORG_TITLE: "OUTSIDE YOUR PORTFOLIO",
    NO_RESULT_IN_MY_ORG_TITLE: "No matches in your organization",
    NO_RESULT_OUTSIDE_ORG_TITLE:
      "No profiles match your search. Try another search term.",
    PRODUCTS_INCLUDE: "Products include:",
    SEARCH_START_TYPING_TEXT: "Start typing to begin your search",
    ERROR_MESSAGE_1: "Sorry, we can't process this request right now",
    ERROR_MESSAGE_2: "Please try again later",
    FOUND: "Found",
    NOT_FOUND: "Not Found",
    PRODUCT_TYPE: "product",
    BY_WORD: " by ",
  },
  GENIE_ACCESS_CODE: "genie_uid",
};
